import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import SlotsTableComp from "./Component/SlotsTableComp"


const SlotsTable =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <SlotsTableComp />
        </div>
        <Footer />
        </>
    )
}

export default SlotsTable;